import { ThemeProvider } from '@material-ui/core/styles'

import InfoTooltip from 'components/Dashboard/common/InfoTooltip'
import overrideTheme from 'theming/overrides/dashboard/sectionRow'
import { RowItem } from 'util/getProviderAccountRows'
import classNames from '@ui-components-3/ui/lib/utils/classNames'

type RowsContentProps = {
  rows: RowItem[]
  className?: string
}

const RowsContent = ({ rows, className }: RowsContentProps): JSX.Element => {
  /* labels can repeat */
  return (
    <ThemeProvider theme={overrideTheme}>
      {rows.map(({ label, value, renderValue, tooltip, testId }, i) =>
        value || value === 0 ? (
          <div key={i} className={classNames('flex flex-col gap-1 mb-6 last:mb-0', className)}>
            <div className="flex items-center">
              <p className="typography-caption text-neutral-500">{label}</p>
              {tooltip ? <InfoTooltip tooltip={tooltip} id={i} /> : null}
            </div>
            {!renderValue ? (
              <h4 data-testid={testId} className="typography-body-l text-neutral-800">
                {value}
              </h4>
            ) : (
              <div>{renderValue(value)}</div>
            )}
          </div>
        ) : null,
      )}
    </ThemeProvider>
  )
}

export default RowsContent
